import { t } from "adapters/i18n";
import type { ProjectedWeight } from "shared/types";
import type { ServiceConstructor } from "../services.types";

export function ProjectedWeightServiceMixin<TBase extends ServiceConstructor>(
  Base: TBase
) {
  return class ProjectedWeightService extends Base {
    readonly projectedWeightUrl = `${process.env.REACT_APP_ENDPOINT}herds/projected-weight`;

    async getLotWeightGainProjection(
      lotId: number
    ): Promise<ProjectedWeight | null> {
      try {
        const result = await this.get(
          `${this.projectedWeightUrl}/from-livestock/${lotId}`
        );

        if (result.data?.data == null) {
          return null;
        }

        const data = result.data.data as ProjectedWeight;

        return data;
      } catch (_) {
        throw new Error(t("livestock:get-lot-projected-weight-error"));
      }
    }
  };
}
